module.exports = __webpack_public_path__ + "img/WT_EN.8a25f235.png";